import type { IBinder } from '../interface/binder';
import type { IBinderListings } from '../interface/binderListings';

export function isBinderListings(object: unknown): object is IBinderListings {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }
    const record: Partial<IBinderListings> = object as Partial<IBinderListings>;

    return (
        !isNullOrUndefined(record.id) &&
        !isNullOrUndefined(record.bindersForSymbol) &&
        !isNullOrUndefined(record.bindersForSymbols) &&
        !isNullOrUndefined(record.exists) &&
        !isNullOrUndefined(record.allKeys) &&
        !isNullOrUndefined(record.allBinders)
    );
}

export function buildBinderListings(
    listings: (IBinder<unknown> | IBinderListings)[],
    id?: symbol,
): Readonly<IBinderListings> {
    const allListings = listings.flatMap(listing =>
        isBinderListings(listing) ? listing.allBinders() : listing,
    );

    return Object.freeze({
        id: id ?? Symbol('binder-listings'),
        bindersForSymbol: (search: symbol) => allListings.find(item => item.id === search),
        bindersForSymbols: (search: symbol[]) =>
            allListings.filter(item => search.includes(item.id)),
        exists: (key: symbol[] | symbol) => allListings.some(item => item.id === key),
        allKeys: () => allListings.map(item => item.id),
        allBinders: () => allListings,
    });
}
